import React, { useMemo } from "react";

function BarChart({ items = [] }) {
  const normalized = useMemo(() => {
    const max = Math.max(...items.map((item) => Number(item.value || 0)), 1);
    return items.map((item) => ({
      ...item,
      height: Math.max(8, Math.round((Number(item.value || 0) / max) * 100)),
    }));
  }, [items]);

  return (
    <div style={{ display: "grid", gridTemplateColumns: `repeat(${Math.max(normalized.length, 1)}, minmax(0, 1fr))`, gap: 12, alignItems: "end" }}>
      {normalized.map((item) => (
        <div key={item.label} style={{ display: "flex", flexDirection: "column", gap: 10, alignItems: "center" }}>
          <div style={{ width: "100%", display: "flex", justifyContent: "center", minHeight: 170, alignItems: "end" }}>
            <div
              style={{
                width: "100%",
                maxWidth: 76,
                height: `${item.height}%`,
                minHeight: 18,
                borderRadius: 18,
                background: `linear-gradient(180deg, ${item.color || "#8bffb0"}, rgba(255,255,255,0.06))`,
                boxShadow: `0 18px 40px ${item.color || "#8bffb0"}33`,
                transition: "height 500ms ease, transform 500ms ease",
                transform: "translateY(0)",
              }}
            />
          </div>
          <div style={{ textAlign: "center" }}>
            <div style={{ color: "#fff", fontWeight: 800, fontSize: 14 }}>{Number(item.value || 0).toLocaleString("en-IN")}</div>
            <div style={{ color: "rgba(255,255,255,0.62)", fontSize: 12, marginTop: 4 }}>{item.label}</div>
          </div>
        </div>
      ))}
    </div>
  );
}

export default React.memo(BarChart);
